import { DestroyRef, Directive, HostBinding, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import type SdInput from '@solid-design-system/components/dist-versioned/components/input/input';
import { SdModelDirective } from '../common/directives/sd-model.directive';

@Directive({
  selector: '[wctSuffix]',
  standalone: true,
})
export class SuffixDirective implements OnInit, OnDestroy {
  @Input({ required: true }) public inputElement!: SdInput;

  @HostBinding('style.padding-left.px') public left: number = 0.1;
  @HostBinding('style.width.px') public width: number = 500;

  private readonly model = inject(SdModelDirective);
  private readonly destroyRef = inject(DestroyRef);

  private readonly canvas: HTMLCanvasElement = document.createElement('canvas');
  private readonly resizeObserver: ResizeObserver;

  constructor() {
    this.resizeObserver = new ResizeObserver(this.updateWidth);
  }

  ngOnInit(): void {
    setTimeout(() => {
      const inputElement: HTMLInputElement = this.inputElement.input;

      const inputStyle: CSSStyleDeclaration = window.getComputedStyle(inputElement);
      const context: CanvasRenderingContext2D | null = this.canvas.getContext('2d');
      context!.font = `${inputStyle.fontSize} ${inputStyle.fontFamily}`;

      this.updatePosition(this.model.value);
      this.model.update.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(this.updatePosition);

      this.width = inputElement.getBoundingClientRect().width;
      this.resizeObserver.observe(inputElement);
    });
  }

  ngOnDestroy(): void {
    this.resizeObserver.disconnect();
  }

  private readonly updatePosition = (text: string): void => {
    const context: CanvasRenderingContext2D | null = this.canvas.getContext('2d');
    this.left = (context?.measureText(text).width ?? 0) + 0.1;
  };

  private readonly updateWidth = (entries: ResizeObserverEntry[]): void => {
    for (const entry of entries) {
      this.width = entry.contentRect.width;
    }
  }
}
